import * as React from "react"
import { SVGProps } from "react"

const Minus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17 11H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2Z" fill="#000" />
  </svg>
)

export default Minus
